<template>
    <section>
        <h1 class="accountProvisionHeader" style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiFileDocumentOutline }}
            </v-icon>
            <span>Account Provisions</span>
        </h1>
        <v-card
            style="margin-top: 2%; padding: 3%;"
            elevation="10"
        >
            <v-tabs
                v-model="tab"
                color="teal darken-3"
                slider-color="teal darken-1"
                background-color="transparent"
                slider-size="3"
                :height="46"
            >
                <v-tab
                    v-for="(item, index) in Object.keys(items)"
                    :key="index"
                    style="padding: 0 50px;"
                >
                    <v-badge :color="item==='all' ? '#444' : item==='active' ? 'success' : item==='inactive' ? 'red' : item==='in progress' ? 'primary' : 'warning'">
                        {{ item === 'pending' ? 'PENDING FOR APPROVAL' : item }}<template #badge>
                            {{ items[item].length }}
                        </template>
                    </v-badge>
                </v-tab>
                <v-spacer />
                <v-btn
                    color="teal darken-1"
                    style="color: white; margin-top: 5px;"
                    :loading="loading.main"
                    @click="refreshAcuListFunc"
                >
                    <v-icon>{{ mdiRefresh }}</v-icon> refresh
                </v-btn>
                <v-tab-item
                    v-for="(itemStatus, indexStatus) in Object.keys(items)"
                    :key="indexStatus"
                    :transition="false"
                >
                    <v-data-table
                        class="accountProvisionTbl"
                        :items="items[itemStatus]"
                        :headers="headers"
                        :loading="loading.main ? 'teal darken-3' : null"
                        :search="search.value"
                        group-by="activePending"
                        :group-desc="tab === 1"
                        :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50, 100],
                            'items-per-page-text': ''
                        }"
                        :show-group-by="activeAndAllTab"
                    >
                        <template #top>
                            <v-text-field
                                v-model="search.query"
                                outlined
                                style="margin: 2px 0;"
                                placeholder="Search"
                                hide-details
                                dense
                                clearable
                                :append-icon="mdiMagnify"
                                color="teal"
                                @click:clear="search.value = null"
                                @keydown.enter.prevent="search.value = search.query"
                                @click:append="search.value = search.query"
                            />
                        </template>
                        <template #[`group.header`]="props">
                            <td
                                v-if="activeAndAllTab && pendingActive && pendingActive.length > 0"
                                :colspan="headers.length"
                                class="sticky-label"
                                style="z-index: 0;"
                            >
                                <span class="sticky-label" style="left: 18px">
                                    <v-icon small>
                                        {{ props.isOpen ? mdiMinus : mdiPlus }}
                                    </v-icon>
                                    <strong>{{ props.group }}</strong>
                                    <span class="grey--text ml-2">
                                        ({{ props.items.length }} item{{ props.items.length > 1 ? 's' : '' }})
                                    </span>
                                </span>
                            </td>
                        </template>
                        <template #item="{ item }">
                            <tr :style="`border: ${item.activePending ? '2px solid red' : ''}`">
                                <td
                                    v-for="header in headers"
                                    :key="header.value"
                                    :style="{ backgroundColor: 'white', textAlign: ['coverages', 'clinics', 'VALIDITY_DAYS'].includes(header.value) ? 'center' : '' }"
                                >
                                    <span style="text-wrap: nowrap;">
                                        <template v-if="header.value === 'ACCT_N'">
                                            <span :style="{ backgroundColor: 'white', width: '100%', height: '100%' }">{{ item[header.value] }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'ACCT_M'">
                                            <span :style="{ backgroundColor: 'white', width: '100%', height: '100%' }">{{ item[header.value] }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'STATUS'">
                                            <div style="min-width: 80px; display: block;">
                                                <span v-if="item.STATUS === 'ACTIVE'"><v-icon color="green">{{ mdiCheckCircle }}</v-icon>Active</span>
                                                <span v-else-if="item.STATUS === 'INACTIVE'"><v-icon color="red">{{ mdiCloseCircle }}</v-icon>Inactive</span>
                                                <span v-else-if="item.STATUS === 'IN PROGRESS'"><v-icon color="primary">{{ mdiClock }}</v-icon>In progress</span>
                                                <span v-else><v-icon color="warning">{{ mdiMinusCircle }}</v-icon>Pending</span>
                                            </div>
                                        </template>
                                        <template v-else-if="header.value === 'AEXP_D'">
                                            <span style="min-width: 120px; display: block; text-align: center;">{{ formattedDate(item.AEXP_D) }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'PDUN_D'">
                                            <span style="min-width: 120px; display: block; text-align: center;">{{ formattedDate(item.PDUN_D) }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'ACTIVE_UNTIL'">
                                            <span style="min-width: 90px; display: block; text-align: center;">{{ formatDate(item.ACTIVE_UNTIL) }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'STATUS_DATE'">
                                            <span style="min-width: 90px; display: block; text-align: center;">{{ formatDate(item.STATUS_DATE) }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'PROVISION_EXPIRY'">
                                            <span style="min-width: 90px; display: block; text-align: center;">{{ formatDate(item.PROVISION_EXPIRY) }}</span>
                                        </template>
                                        <template v-else-if="header.value === 'membStat'">
                                            <div style="text-wrap: nowrap; display: block;">
                                                <span v-if="item.MEMB_MONTHS > 0">Available after <b> {{ `${item.MEMB_MONTHS} month${item.MEMB_MONTHS > 1 ? 's' : ''}` }} of continuous membership</b>, or</span>
                                                <span v-else>Available on the <b>first day of membership</b>, or</span>
                                            </div>
                                            <div style="text-wrap: nowrap; display: block;">
                                                <span v-if="item.PAID_MEMB_MONTHS > 0">after <b>{{ `${item.PAID_MEMB_MONTHS} month${item.PAID_MEMB_MONTHS > 1 ? 's' : ''}` }} of membership </b><br>provided that</span>
                                                <span v-else> on the <b>first day of membership</b><br>provided that </span>
                                                <b> {{ `${item.PAID_MONTHS} month${item.PAID_MONTHS > 1 ? 's' : ''} of payment` }}</b> has been made.
                                            </div>
                                        </template>
                                        <template v-else-if="header.value === 'USE_STORED_RATES'">
                                            <div style="width: 55px;">
                                                <span v-if="item.USE_STORED_RATES === 1"><v-icon color="green" style="display: inline-block;">{{ mdiCheckCircle }}</v-icon> Yes</span>
                                                <span v-else><v-icon color="red">{{ mdiCloseCircle }}</v-icon> No</span>
                                            </div>
                                        </template>
                                        <template v-else-if="header.value === 'Contract'">
                                            <div v-if="item.CONTRACT_PATH !== null" style="width: 80px; display: inline-block;" elevation="0">
                                                <v-tooltip top>
                                                    <template #activator="{ on }">
                                                        <v-chip
                                                            v-on="on"
                                                            @click="handleCopyContractPath(item)"
                                                        ><v-icon small color="green">{{ mdiClipboardOutline }}</v-icon></v-chip>

                                                    </template>
                                                    <span>Copy link, then paste into a new tab</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template #activator="{ on }">
                                                        <v-chip

                                                            v-on="on"
                                                            @click="handleShowContractPath(item)"
                                                        ><v-icon small color="blue">{{ mdiLink }}</v-icon></v-chip>
                                                    </template>
                                                    <span>View the link</span>
                                                </v-tooltip>
                                            </div>
                                            <div v-else style="width: 80px; display: inline-block;"></div>
                                            |
                                            <div v-if="item.INTERNAL_ENDORSEMENT !== null" style="display: inline-block;">
                                                <v-tooltip top>
                                                    <template #activator="{ on }">
                                                        <v-chip

                                                            v-on="on"
                                                            @click="handleShowSpecialDeals(item)"
                                                        ><v-icon small color="blue">{{ mdiTag }}</v-icon></v-chip>
                                                    </template>
                                                    <span>Show Special Deals</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                        <template v-else-if="header.value === 'coverages'">
                                            <v-tooltip top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        class="white--text position-relative-coverages"
                                                        icon
                                                        :loading="selectedAcu && selectedAcu.ACCT_N === item.ACCT_N ? loading.coverage : false"
                                                        :style="{ backgroundColor: item.BENEFITS_STATUS === 'PENDING' && item.STATUS === 'ACTIVE' && pendingActive && pendingActive.length > 0 && activeAndAllTab ? '#fcf75e' : '' }"
                                                        v-on="on"
                                                        @click="handleShowCoverages(item)"
                                                    >
                                                        <template #loader>
                                                            <v-progress-circular indeterminate color="primary" size="20" />
                                                        </template>
                                                        <v-icon
                                                            color="primary"
                                                            :class="{
                                                                'attention-needed-coverages': item.BENEFITS_STATUS === 'PENDING',
                                                                'pulse-animation-coverages': item.BENEFITS_STATUS === 'PENDING'
                                                            }"
                                                        >{{ mdiEye }}
                                                        </v-icon>
                                                        <v-badge
                                                            v-if="item.BENEFITS_STATUS === 'PENDING'"
                                                            color="error"
                                                            dot
                                                            offset-x="10"
                                                            offset-y="10"
                                                        />
                                                    </v-btn>
                                                </template>
                                                <span>{{ item.BENEFITS_STATUS === 'PENDING' ? 'Action Required!' : 'Show Coverages' }}</span>
                                            </v-tooltip>
                                        </template>
                                        <template v-else-if="header.value === 'actions'">
                                            <div style="width: 110px; margin: 0 auto; text-align: center;">
                                                <v-tooltip top>
                                                    <template #activator="{ on }">
                                                        <v-btn
                                                            class="white--text"
                                                            icon
                                                            v-on="on"
                                                            @click="handleShowHistory(item)"
                                                        ><v-icon color="primary">{{ mdiFileEye }}</v-icon></v-btn>
                                                    </template>
                                                    <span>Show History</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template #activator="{ on }">
                                                        <v-btn
                                                            class="white--text"
                                                            icon
                                                            v-on="on"
                                                            @click="handleAcuUpdate(item)"
                                                        ><v-icon color="warning">{{ mdiPencil }}</v-icon></v-btn>
                                                    </template>
                                                    <span>Edit</span>
                                                </v-tooltip>
                                                <v-icon
                                                    v-if="item.STATUS === 'ACTIVE'"
                                                    color="success"
                                                    style="padding: 0 7px;"
                                                >{{ mdiCheckDecagram }}</v-icon>
                                                <v-tooltip
                                                    v-if="item.BENEFITS_STATUS === 'PENDING' && item.STATUS === 'PENDING' || item.CLINICS_STATUS === 'PENDING' && item.STATUS === 'PENDING'"
                                                    top
                                                >
                                                    <template #activator="{ on }">
                                                        <v-btn
                                                            class="white--text"
                                                            icon
                                                            v-on="on"
                                                            @click="handleShowApproveWarning(item, item.BENEFITS_STATUS === 'PENDING' ? 'benefitStatus' : 'clinicStatus')"
                                                        ><v-icon color="secondary">{{ mdiCheckDecagram }}</v-icon></v-btn>
                                                    </template>
                                                    <span>Approve Changes</span>
                                                </v-tooltip>
                                                <v-tooltip
                                                    v-else-if="item.BENEFITS_STATUS === 'ACTIVE' && item.STATUS === 'PENDING' || item.CLINICS_STATUS === 'ACTIVE' && item.STATUS === 'PENDING'"
                                                    top
                                                >
                                                    <template #activator="{ on }">
                                                        <v-btn
                                                            class="white--text"
                                                            icon
                                                            v-on="on"
                                                            @click="handleAcuApprove(item)"
                                                        ><v-icon color="secondary">{{ mdiCheckDecagram }}</v-icon></v-btn>
                                                    </template>
                                                    <span>Approve Changes</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                        <template v-else-if="header.value === 'clinics'">
                                            <v-tooltip top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        class="white--text position-relative-coverages"
                                                        icon
                                                        :loading="showClinics.data && showClinics.data.ACCT_N === item.ACCT_N ? loading.clinic : false"
                                                        :style="{ backgroundColor: item.CLINICS_STATUS === 'PENDING' && item.STATUS === 'ACTIVE' && pendingActive && pendingActive.length > 0 && activeAndAllTab ? '#fcf75e' : '' }"
                                                        v-on="on"
                                                        @click="handleShowClinics(item)"
                                                    >
                                                        <template #loader>
                                                            <v-progress-circular indeterminate color="primary" size="20" />
                                                        </template>
                                                        <v-icon
                                                            color="primary"
                                                            :class="{
                                                                'attention-needed-coverages': item.CLINICS_STATUS === 'PENDING',
                                                                'pulse-animation-coverages': item.CLINICS_STATUS === 'PENDING'
                                                            }"
                                                        >{{ mdiEye }}
                                                        </v-icon>
                                                        <v-badge
                                                            v-if="item.CLINICS_STATUS === 'PENDING'"
                                                            color="error"
                                                            dot
                                                            offset-x="10"
                                                            offset-y="10"
                                                        />
                                                    </v-btn>
                                                </template>
                                                <span>{{ item.CLINICS_STATUS === 'PENDING' ? 'Action Required!' : 'Show Clinics' }}</span>
                                            </v-tooltip>
                                        </template>
                                        <template v-else>
                                            {{ item[header.value] }}
                                        </template>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs>
        </v-card>
        <UpdateAcuContract
            :show="showUpdateAcu"
            :selected-acu="selectedAcu"
            @refreshAcuList="refreshAcuList"
            @closeDialog="showUpdateAcu = false"
        />
        <Coverages
            :show="showCoveragesAcu"
            :selected-acu="selectedAcu"
            @refreshAcuList="refreshAcuList"
            @closeDialog="showCoveragesAcu = false"
        />
        <ShowApprove
            :show="showApproveAcu"
            :selected-acu="selectedAcu"
            @refreshAcuList="refreshAcuList"
            @closeDialog="showApproveAcu = false"
        />
        <v-snackbar
            v-model="snackbar.status"
            :timeout="snackbar.timeout"
        >
            {{ snackbar.text }}
            <template #action="{ attrs }">
                <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    style="text-transform: none;"
                    @click="snackbar.status = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <ShowContract
            :show-contract-path="showContractPath"
            @closeDialog="showContractPath.status = false"
        />
        <ShowApproveWarning
            :show="showWarning.status"
            :data="showWarning.data"
            @closeDialog="showWarning.status = false"
            @handleShowPending="handleShowPending"
        />
        <ShowHistory
            :show="historyShow.status"
            :data="historyShow.data"
            @closeDialog="historyShow.status = false"
        />
        <ShowClinics
            :show="showClinics.status"
            :data="showClinics.data"
            @refreshAcuList="refreshAcuList"
            @closeDialog="handleCloseClinics"
        />
        <ShowSpecialDeals
            :show-special-deals="showSpecialDeals"
            @closeDialog="showSpecialDeals.status = false"
        />
    </section>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import UpdateAcuContract from './UpdateAcuContract.vue'
import Coverages from './CoveragesPage/IndexPage.vue'
import ShowContract from './ShowContract.vue'
import ShowApprove from './ShowApprove.vue'
import ShowApproveWarning from './ShowApproveWarning.vue'
import ShowHistory from './ShowHistory.vue'
import ShowClinics from './ClinicsPage/IndexPage.vue'
import ShowSpecialDeals from './ShowSpecialDeals.vue'
import {
    mdiFileDocumentOutline,
    mdiRefresh,
    mdiMagnify,
    mdiMinus,
    mdiPlus,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiClock,
    mdiMinusCircle,
    mdiClipboardOutline,
    mdiLink,
    mdiTag,
    mdiEye,
    mdiFileEye,
    mdiPencil,
    mdiCheckDecagram
} from '@mdi/js'

export default {
    components: { UpdateAcuContract, Coverages, ShowContract, ShowApprove, ShowApproveWarning, ShowHistory, ShowClinics, ShowSpecialDeals },
    data: ()=>({
        mdiFileDocumentOutline,
        mdiRefresh,
        mdiMagnify,
        mdiMinus,
        mdiPlus,
        mdiCheckCircle,
        mdiCloseCircle,
        mdiClock,
        mdiMinusCircle,
        mdiClipboardOutline,
        mdiLink,
        mdiTag,
        mdiEye,
        mdiFileEye,
        mdiPencil,
        mdiCheckDecagram,
        hoveredRow: null,
        refreshIntervalId: null,
        tab: null,
        showClinics: {
            status: false,
            data: null
        },
        showSpecialDeals: {
            status: false,
            path: null
        },
        showContractPath: {
            status: false,
            path: null
        },
        historyShow: {
            status: false,
            data: null
        },
        showWarning: {
            status: false,
            data: null
        },
        snackbar: {
            status: null,
            text: null,
            timeout: 2000
        },
        selectedAcu: null,
        showApproveAcu: false,
        showUpdateAcu: false,
        showCoveragesAcu: false,
        search: {
            value: null,
            query: null
        },
        loading : {
            main: false,
            clinic: false,
            coverage: false
        },
        items: {
            all: [],
            active: [],
            inactive: [],
            pending: [],
            'in progress': []
        },
        headers: [
            { text: 'Acc. Number', value: 'ACCT_N', groupable: false,sortable: false },
            { text: 'Acc. Name', value: 'ACCT_M', groupable: false },
            { text: 'Acc. Expiry Date', value: 'AEXP_D', groupable: false },
            { text: 'Pd. Until', value: 'PDUN_D', groupable: false },
            { text: 'Mode of Payment', value: 'MODE_OF_PAYMENT', groupable: false },
            { text: 'Status', value: 'STATUS', groupable: false },
            { text: 'Portal Active Date', value: 'STATUS_DATE', groupable: false },
            { text: 'Portal Active Until', value: 'ACTIVE_UNTIL', groupable: false },
            { text: 'ACU Eligibility', value: 'membStat', groupable: false,sortable: false },
            { text: 'Provision Expiry Date', value: 'PROVISION_EXPIRY', groupable: false },
            { text: 'Approval Validity Days', value: 'VALIDITY_DAYS', groupable: false },
            { text: 'Use Stored Rates', value: 'USE_STORED_RATES', groupable: false },
            { text: 'Read Full Contract', value: 'Contract', groupable: false, sortable: false },
            { text: 'Coverages', value: 'coverages', groupable: false, sortable: false },
            { text: 'Clinics', value: 'clinics', groupable: false, sortable: false },
            { text: 'Actions', value: 'actions', align: 'center', groupable: false, sortable: false }
        ],
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['acuActiveListData', 'getStatusProvisionData', 'viewAccountClinicsData', 'viewAccountCoveragesData']),
        isSortActive() {
            return this.options.sortBy && this.options.sortBy.length > 0
        },
        activeAndAllTab() {
            return this.tab === 0 || this.tab === 1
        },
        pendingActive () {
            const test = this.items.all.filter(item => item.STATUS === 'ACTIVE' && (item.BENEFITS_STATUS === 'PENDING' || item.CLINICS_STATUS === 'PENDING'))
            return test
        }
    },
    watch: {
        viewAccountCoveragesData() {
            this.showCoveragesAcu = true
            this.loading.coverage = false
            this.loading.main = false
        },
        viewAccountClinicsData(newVal) {
            if (newVal && newVal.status === 200) {
                this.showClinics.status = true
            }
            this.loading.clinic = false
            this.loading.main = false
        },
        'search.query'(newVal) {
            if (newVal === '') {
                this.search.value = null
            }
        },
        getStatusProvisionData(newVal) {
            // Stop loading indicators when API response arrives
            this.loading.main = false
            this.loading.coverage = false

            // Only proceed if API request was successful
            if (newVal.status !== 200) return

            // Store API data in a variable so we don't repeatedly type newVal.data
            const data = newVal.data

            // Account number is used as the unique identifier in our tables
            const acctNumber = data.ACCT_N

            // Convert status to lowercase because our items object keys are lowercase
            // Example: STATUS = "ACTIVE" -> items["active"]
            const statusKey = data.STATUS.toLowerCase()

            // Check if this ACTIVE account still has pending items
            // If either BENEFITS or CLINICS is pending, we show it as
            // "Active with Pending Changes"
            const hasPending =
                data.BENEFITS_STATUS === 'PENDING' ||
                data.CLINICS_STATUS === 'PENDING'

            // Determine the label used for grouping in the table
            // This affects how the v-data-table group-by behaves
            const activePending =
                data.STATUS === 'ACTIVE'
                    ? (hasPending ? 'Active with Pending Changes' : 'Active')
                    : 'All'

            // Create the updated row object
            // Spread operator ensures we copy the API data
            // while also adding our custom field (activePending)
            const updatedItem = { ...data, activePending }

            /*
                -----------------------------------------------------
                STEP 1: Update the "ALL" tab
                -----------------------------------------------------

                The ALL tab contains every account regardless of status.
                Instead of removing and pushing again, we replace the item
                in place to keep Vue 2 reactivity working properly.
            */
            const allIndex = this.items.all.findIndex(item => item.ACCT_N === acctNumber)

            // If the account cannot be found in ALL tab, something went wrong.
            // To prevent inconsistent UI state, we force reload the whole list.
            if (allIndex < 0) {
                this.refreshAcuListFunc()
                return
            }

            // Replace the item in the ALL array
            // splice is used because Vue 2 cannot detect direct index assignment
            this.items.all.splice(allIndex, 1, updatedItem)

            /*
                -----------------------------------------------------
                STEP 2: Remove the account from all status tabs
                -----------------------------------------------------

                Since the account status might have changed
                (example: PENDING -> ACTIVE),
                we first remove the account from all status arrays.

                After that, we will add it back to the correct tab.
            */
            const tabs = ['active', 'inactive', 'pending', 'in progress']

            tabs.forEach(tab => {
                if (Array.isArray(this.items[tab])) {
                    this.items[tab] = this.items[tab].filter(
                        item => item.ACCT_N !== acctNumber
                    )
                }
            })

            /*
                -----------------------------------------------------
                STEP 3: Add the account to the correct status tab
                -----------------------------------------------------

                The tab name is based on STATUS from the API response.
                Example:
                STATUS = ACTIVE -> items["active"]
            */

            // Ensure the array exists before pushing
            if (!this.items[statusKey]) {
                this.items[statusKey] = []
            }

            // Add the updated account to its new status tab
            this.items[statusKey].push(updatedItem)

            /*
                -----------------------------------------------------
                STEP 4: Sort the tab alphabetically
                -----------------------------------------------------

                Sorting keeps the UI consistent and easier to read
                when accounts are added dynamically.
            */
            this.items[statusKey].sort((a, b) =>
                a.ACCT_M.toLowerCase().localeCompare(b.ACCT_M.toLowerCase())
            )
        },
        acuActiveListData(newVal) {
            // Only continue if API response is successful
            if (newVal && newVal.status === 200) {
                // These arrays represent the data for each tab in the UI
                const all = []
                const active = []
                const inactive = []
                const pending = []
                const in_progress = []
                // Loop through every account returned by the API
                newVal.data.forEach(item => {
                    // Check if ACTIVE account still has pending setups
                    const hasPending =
                        item.BENEFITS_STATUS === 'PENDING' ||
                        item.CLINICS_STATUS === 'PENDING'

                    /*
                        -------------------------------------------------
                        STEP 1: Handle ACTIVE accounts
                        -------------------------------------------------
                    */
                    if (item.STATUS === 'ACTIVE') {
                        // If ACTIVE but still has pending setups
                        if (hasPending) {
                            // Put these at the top of the ACTIVE list
                            active.unshift({ ...item, activePending: 'Active with Pending Changes' })
                            // Also appear in ALL tab
                            all.unshift({ ...item, activePending: 'Active with Pending Changes' })
                        } else {
                            // Normal ACTIVE accounts
                            active.push({ ...item, activePending: 'Active' })
                            all.push({ ...item, activePending: 'All' })
                        }
                    } else {
                        // Non-active accounts still appear in ALL tab
                        all.push({ ...item, activePending: 'All' })
                    }

                    /*
                        -------------------------------------------------
                        STEP 2: Sort accounts into their status tabs
                        -------------------------------------------------
                    */

                    if (item.STATUS === 'INACTIVE') {
                        inactive.push(item)
                    } else if (item.STATUS === 'PENDING') {
                        pending.push(item)
                    } else if (item.STATUS === 'IN PROGRESS') {
                        in_progress.push(item)
                    }
                })

                /*
                    -------------------------------------------------
                    STEP 3: Update table data used by v-data-table
                    -------------------------------------------------
                */

                this.items.active = active
                this.items.inactive = inactive
                this.items.pending = pending
                this.items['in progress'] = in_progress
                this.items.all = all

                /*
                    -------------------------------------------------
                    STEP 4: Update selected account reference
                    -------------------------------------------------

                    If the currently viewed account exists in the new data,
                    we update its reference to keep it in sync with the table.
                */

                if (this.showClinics.data) {
                    this.showClinics.data =
                        newVal.data.find(item =>
                            item.ACCT_N == this.showClinics.data.ACCT_N
                        )
                } else if (this.selectedAcu) {
                    this.selectedAcu =
                        newVal.data.find(item =>
                            item.ACCT_N == this.selectedAcu.ACCT_N
                        )
                }
            }
            // Stop loading indicator
            this.loading.main = false
        }
    },
    created() {
        // this.getCsrfToken()
        this.suggestAcuDiagnostics()
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.refreshAcuListFunc()
        this.refreshIntervalId = setInterval(() => {
            if (!this.showClinics.status && !this.showContractPath.status && !this.historyShow.status && !this.showWarning.status && !this.showApproveAcu && !this.showUpdateAcu && !this.showCoveragesAcu) {
                this.refreshAcuListFunc()
            }
        }, 300000)
    },
    beforeDestroy() {
        this.cancelAcuActiveList()
    },
    destroyed() { 
        window.removeEventListener('resize', this.onResize)
        if (this.refreshIntervalId) {
            clearInterval(this.refreshIntervalId)
        }
    },
    methods: {
        ...mapActions(['acuActiveList', 'getCsrfToken', 'getStatusProvision', 'suggestAcuDiagnostics', 'viewAccountClinics', 'viewAccountCoverages', 'cancelAcuActiveList']),
        handleCloseClinics() {
            this.$store.commit('VIEW_ACCOUNT_CLINICS', null)
            this.showClinics.status = false
        },
        async handleShowClinics(data) {
            this.loading.main = true
            this.showClinics.data = data
            this.loading.clinic = true
            await this.viewAccountClinics({ ACCT_N: data.ACCT_N })
            if (this.viewAccountClinicsData.status === 200) {
                this.showClinics.status = true
            }
        },
        handleShowHistory(data) {
            this.historyShow.status = true
            this.historyShow.data = data
        },
        handleShowApproveWarning(data, status) {
            let tempData = structuredClone(data)
            tempData.pending = status
            this.showWarning.data = tempData
            this.showWarning.status = true
        },
        refreshAcuListFunc() {
            this.loading.main = true
            this.acuActiveList()
        },
        async refreshAcuList(ACCT_N) {
            this.loading.main = true
            await this.getStatusProvision({ ACCT_N })
        },
        handleAcuApprove(item) {
            this.showApproveAcu = true
            this.selectedAcu = item
        },
        handleShowContractPath(item) {
            this.showContractPath.status = true
            this.showContractPath.path = item.CONTRACT_PATH
            this.showContractPath.acctName = item.ACCT_M
        },
        handleShowSpecialDeals(item) {
            this.showSpecialDeals.status = true
            this.showSpecialDeals.path = item.INTERNAL_ENDORSEMENT
            this.showSpecialDeals.acctName = item.ACCT_M
        },
        handleCopyContractPath(item) {
            const contractPath = `file://${item.CONTRACT_PATH}`

            if (!contractPath) {
                this.snackbar.status = true
                this.snackbar.text = 'No contract path to copy.'
                return
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                // Use the modern Clipboard API
                navigator.clipboard.writeText(contractPath)
                    .then(() => {
                        this.snackbar.status = true
                        this.snackbar.text = 'Contract path copied successfully!'
                    })
                    .catch(() => {
                        this.snackbar.status = true
                        this.snackbar.text = 'Failed to copy contract path. Please try again.'
                    })
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea')
                textArea.value = contractPath
                document.body.appendChild(textArea)
                textArea.select()
                try {
                    document.execCommand('copy')
                    this.snackbar.status = true
                    this.snackbar.text = 'Contract path copied successfully!'
                } catch (err) {
                    this.snackbar.status = true
                    this.snackbar.text = 'Failed to copy contract path. Please try again.'
                } finally {
                    document.body.removeChild(textArea)
                }
            }
        },
        async handleShowCoverages(item) {
            this.selectedAcu = item
            this.loading.coverage = true
            this.loading.main = true
            await this.viewAccountCoverages({ ACCT_N: this.selectedAcu.ACCT_N })
            if (this.viewAccountCoveragesData.status === 200) {
                this.showCoveragesAcu = true
            }
        },
        handleShowPending(item) {
            if (this.showWarning.status) {
                this.showWarning.status = false
            }
            if (item.pending === 'benefitStatus') {
                this.handleShowCoverages(item)
            } else {
                this.handleShowClinics(item)
            }
        },
        handleAcuUpdate(item) {
            this.showUpdateAcu = true
            this.selectedAcu = item
        },
        formatDate(date) {
            if (date)
                return moment(date).utcOffset('+0800').format('MMMM D, YYYY')
            else
                return '-'
        },
        formattedDate(date) {
            if (date)
                return moment(date).format('MMMM D, YYYY')
            else
                return '-'
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.accountProvisionTbl > div > table > thead > tr > th {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
    background: #eee;
    top: 0;
}
.accountProvisionTbl > div > table > tbody > tr > td:nth-child(1) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    left: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background-color: white;
}
.accountProvisionTbl > div > table > thead > tr > th:nth-child(1) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    left: 0;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background-color: #eee;
}
.accountProvisionTbl > div > table > tbody > tr > td:nth-child(2) {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    left: 77px; /* This should be the width of the first column to make the second one sticky after the first one */
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
}
.accountProvisionTbl > div > table > thead > tr > th:nth-child(2) {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    left: 77px; /* This should be the width of the first column to make the second one sticky after the first one */
    z-index: 5; /* Ensure the second column has a lower z-index than the first one */
    background-color: #eee;
}
.accountProvisionTbl .v-data-table__wrapper {
    max-height: 70vh; /* Adjust the height according to your needs */
    overflow-y: auto; /* Enable vertical scrolling */
}
.accountProvisionHeader {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.sticky-label {
  position: sticky;
  left: 0;
  background: transparent;
  padding: 4px 8px;
  font-weight: 500;

  white-space: nowrap;   /* prevent line break */
  overflow: visible;     /* allow overflow */
  width: 100%;    /* expand width based on text */
}
/* Define the pulse animation */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Apply animation when needed */
.attention-needed-coverages {
  color: red !important; /* Use error color instead of primary */
}

.pulse-animation-coverages {
  animation: pulse 1.5s infinite ease-in-out;
}

/* For positioning the badge */
.position-relative-coverages {
  position: relative;
}
</style>
